const EmptyWishListIcon = ({ width = 180, height = 180, color = 'black' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 180 180"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.83319 105.156C5.76605 125.097 26.2077 122.92 36.687 119.338C41.5677 117.762 50.4677 117.275 47.0225 127.933C42.716 141.256 41.8546 173.489 118.296 142.116C194.737 110.743 174.863 62.8472 152.748 67.7656C115.066 76.1461 130.166 60.4595 118.296 47.9961C76.9529 4.58928 10.4171 80.2289 7.83319 105.156Z"
        fill="#FEE5E5"
      />
      <path
        d="M130.734 36.9568L132.467 28.4609"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M139.37 41.2998L145.447 35.2515"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M145.21 48.2226L153.609 46.3815"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M55 55C55 51.6863 57.6863 49 61 49H109.743H123C126.314 49 129 51.6863 129 55V64.792V126C129 129.314 126.314 132 123 132H61C57.6863 132 55 129.314 55 126V55Z"
        fill="white"
      />
      <path d="M65 64H117" stroke={color} strokeWidth="3.15" strokeLinecap="round" />
      <path
        d="M75.1924 48.2705V46.186C75.1924 43.8742 73.3182 42 71.0064 42V42C68.6945 42 66.8203 43.8742 66.8203 46.186V49.1683C66.8203 51.8881 69.0252 54.093 71.7451 54.093V54.093"
        stroke={color}
        strokeWidth="2.7907"
        strokeLinecap="round"
      />
      <path
        d="M95.5674 48.2705V46.186C95.5674 43.8742 93.6932 42 91.3814 42V42C89.0695 42 87.1953 43.8742 87.1953 46.186V49.1683C87.1953 51.8881 89.4002 54.093 92.1201 54.093V54.093"
        stroke={color}
        strokeWidth="2.7907"
        strokeLinecap="round"
      />
      <path
        d="M115.004 48.2705V45.7209C115.004 43.6659 113.338 42 111.283 42V42C109.228 42 107.562 43.6659 107.562 45.7209V49.7155C107.562 52.1331 109.522 54.093 111.94 54.093V54.093"
        stroke={color}
        strokeWidth="2.7907"
        strokeLinecap="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M89.5455 82.3376C91.0506 83.7991 91.757 85.3321 91.757 85.3321C91.757 85.3321 92.3864 83.7707 93.8828 82.2972C95.2198 80.9807 97.2487 79.7344 100.139 79.7344C106.264 79.7344 109.703 85.0976 109.703 90.68C109.703 99.8742 91.7569 111.039 91.7569 111.039C91.7569 111.039 73.7031 99.7647 73.7031 90.68C73.7031 85.2071 77.0343 79.7344 83.3748 79.7344C86.1409 79.7344 88.1746 81.0063 89.5455 82.3376ZM91.759 106.99C92.0211 106.81 92.3066 106.611 92.6117 106.395C94.2311 105.25 96.3744 103.641 98.5028 101.771C100.647 99.8878 102.684 97.8208 104.159 95.7694C105.679 93.655 106.328 91.9376 106.328 90.68C106.328 86.2083 103.727 83.1094 100.139 83.1094C98.2294 83.1094 96.9666 83.9436 96.0975 84.8581C94.9741 86.0403 93.9836 87.3821 92.9429 88.6781C92.3252 89.4472 91.1819 89.4533 90.5549 88.6919C89.495 87.405 88.4586 86.0467 87.3304 84.8944C86.3658 83.9092 85.0864 83.1094 83.3748 83.1094C81.2896 83.1094 79.8265 83.963 78.807 85.2502C77.7241 86.6177 77.0781 88.583 77.0781 90.68C77.0781 91.8966 77.721 93.5948 79.2564 95.7126C80.7426 97.7624 82.794 99.8352 84.954 101.728C87.0976 103.605 89.256 105.226 90.8868 106.381C91.1992 106.602 91.4913 106.806 91.759 106.99Z"
        fill={color}
      />
      <path
        d="M122.5 49H61C57.6863 49 55 51.6863 55 55V126C55 129.314 57.6863 132 61 132H123C126.314 132 129 129.314 129 126V60.0177"
        stroke={color}
        strokeWidth="3.15"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default EmptyWishListIcon
